<template>
  <div class="modal-container">
    <div class="modal">
      <div class="modal-dialog modal-dialog-scrollable modal-xl">
        <div
          v-on-clickaway="close"
          class="modal-content"
        >
          <div class="modal-header">
            <slot name="header" />
          </div>
          <div class="modal-body">
            <slot name="body" />
          </div>
          <div class="modal-footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop"/>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway2'

export default {
  name: 'Modal',
  directives: {
    onClickaway
  },
  props: {
    close: {
      type: Function,
      required: true
    }
  }
}
</script>

<style>
  .modal-body .v-select .vs__dropdown-menu {
    position: relative;
  }
</style>
